import { ApiKey } from "src/modules/api/common/request/apiKey";
import {
  GetUserPontaPointFromCartRequest,
  GetUserPontaPointFromCartResponse,
} from "./types";

import { useApiTrigger } from "src/modules/api/common/request/useApiTrigger";
import { useCachedApi } from "../../common/request/useCachedApi";

export const useGetUserPontaPointFromCartTrigger = () => {
  return useApiTrigger<
    GetUserPontaPointFromCartResponse,
    GetUserPontaPointFromCartRequest
  >({
    method: ApiKey.GET_USER_PONTA_POINT_FROM_CART,
  });
};

export const useGetUserPontaPointFromCart = (
  params: GetUserPontaPointFromCartRequest,
  shouldFetch = true
) => {
  return useCachedApi<GetUserPontaPointFromCartResponse>({
    method: ApiKey.GET_USER_PONTA_POINT_FROM_CART,
    params,
    shouldFetch,
  });
};
